export const regexExpression = {
    regexEmail: /^[A-Z0-9._%+-]+@[A-Z0-9./_*/-]+\.[A-Z]{2,4}$/i,
    regexText: new RegExp(/^[a-zA-Z0-9ก-๙/,&./ ]*$/),
    regexTextOrWhiteSpace: new RegExp(/^[a-zA-Z0-9ก-๙/,&.()]*$/),
    regexTextLimit: new RegExp(/^[a-zA-Z0-9ก-๙/,&. ]{5,}$/),
    regexPassword: new RegExp(/^[a-zA-Z0-9!@#$%^&*()_+-=]{5,}$/),
    regexTel: new RegExp(/^[0-9-]{10,10}$/),
    regexImage: new RegExp(/\.(jpe?g|png|gif|bmp)$/i)
};
